// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1mO3P","addWidgetButton":"Header_addWidgetButton__WOdkb","dashboardTabs":"Header_dashboardTabs__1IeQn","active":"Header_active__364AC"};